import _ from 'lodash'
import { CancelToken } from 'axios'

import { deserializeMydActivity } from '_actions/myd_activities'
import { _deserializeMydPlanningData } from '_actions/myd_plannings'
import { deserializeRelationship } from 'utils/relationships'
import {
  FETCHING_MYD_EVALUATIONS,
  FETCHED_MYD_EVALUATIONS,
  UPDATING_MYD_EVALUATION,
  UPDATED_MYD_EVALUATION,
  FETCHING_MYD_EVALUATION,
  FETCHED_MYD_EVALUATION,
} from '_reducers/myd_evaluations'
import { MydAPI } from '_services/default'
import {
  deserializeWidgetData,
  defaultFields as widgetDefaultFields,
} from '_actions/widgets'


export const defaultFields = () => {
  const defaultFields = {
    'fields[myd_evaluation]': [
      'id',
      'date',
      'myd_activity',
      'myd_planning',
      'widgets',
    ].join(','),
    'fields[myd_activity]': [
      'id',
      'title',
    ].join(','),
    'fields[user]': [
      'avatar',
      'eportfolio_url',
      'first_name',
      'last_name',
      'username',
      'url',
    ].join(','),
    'fields[myd_planning]': [
      'id',
      'name',
      'treenodes',
    ].join(','),
    'fields[tree_node]': [
      'id',
    ].join(','),
    'fields[widget]': 'id',
  }

  return defaultFields
}


const _fetchingMydEvaluation = () => ({
  type: FETCHING_MYD_EVALUATION,
})

const _fetchedMydEvaluation = mydEvaluation => ({
  type: FETCHED_MYD_EVALUATION,
  mydEvaluation,
})


const _fetchingMydEvaluations = () => ({
  type: FETCHING_MYD_EVALUATIONS,
})

const _fetchedMydEvaluations = (mydEvaluations, meta) => ({
  type: FETCHED_MYD_EVALUATIONS,
  mydEvaluations,
  meta,
})

export function deserializeMydEvaluation(mydEvaluation, included) {
  let { id, attributes, relationships } = mydEvaluation

  let widgets, mydPlanning

  if (_.has(relationships.widgets, 'data') && relationships.widgets.data) {
    widgets = deserializeRelationship(relationships.widgets, included, deserializeWidgetData)
  }

  if (_.has(relationships.mydPlanning, 'data')) {
    mydPlanning = deserializeRelationship(relationships.mydPlanning, included, _deserializeMydPlanningData)
  }

  return {
    id: id,
    ...attributes,
    mydActivity: deserializeRelationship(relationships.mydActivity, included, deserializeMydActivity),
    mydPlanning,
    widgets,
  }
}

export const emptyMydEvaluations = () => (
  dispatch => {
    dispatch(
      _fetchedMydEvaluations({
        type: FETCHED_MYD_EVALUATIONS,
        mydEvaluations: [],
        meta: {}
      })
    )
  }
)

export function updateDateMydEvaluation(mydEvaluationId, date) {
  return dispatch => new Promise((resolve, reject) => {
    dispatch({
      type: UPDATING_MYD_EVALUATION,
    })

    let data = {
      attributes: {
        date,
      },
      id: _.toString(mydEvaluationId),
      type: 'myd_evaluation',
    }

    MydAPI.patch(`/myd/evaluations/${mydEvaluationId}?include=myd_activity.myd_competences,myd_planning`, {data}).then(res => {
      const mydEvaluation = deserializeMydEvaluation(res.data.data, res.data.included)
      dispatch({
        type: UPDATED_MYD_EVALUATION,
        mydEvaluation,
      })
      resolve(mydEvaluation)

    }).catch(reject)
  })
}

export function addMydEvaluation(mydPlanningId, mydActivityId) {
  return new Promise((resolve, reject) => {
    let data = {
      attributes: {
        myd_activity_id: _.toString(mydActivityId),
        planning_id: _.toString(mydPlanningId),
        date: null,
      },
      type: 'myd_evaluation',
    }

    MydAPI.post('/myd/evaluations?include=myd_activity.myd_competences,myd_planning', {data}).then(res => {
      resolve(deserializeMydEvaluation(res.data.data, res.data.included))
    }).catch(reject)
  })
}


export function removeMydEvaluation(mydEvaluationId) {
  return MydAPI.delete(`/myd/evaluations/${mydEvaluationId}`)
}

export const fetchMydEvaluationsByFieldId = (url, fieldId, _cancelToken, _many=true, relation='myd_evaluations', includes='', fields=false) => {
  return dispatch => new Promise((resolve, reject) => {
    if (_many) {
      dispatch(_fetchingMydEvaluations())
    } else {
      dispatch(_fetchingMydEvaluation())
    }

    if (_cancelToken)
      _cancelToken()

    MydAPI.get(
      `${url}/${fieldId}/relationships/${relation}`,
      {
        params: {
          ...(
            includes ?
            {include: includes} :
            {include: `${relation}.widgets,${relation}.widgets.likes,${relation}.widgets.global_evaluations,${relation}.widgets.treenodes,${relation}.widgets.owner,${relation}.myd_activity.myd_competences,${relation}.myd_planning.treenodes`}
          ),
          ...(fields && fields),
        },
        cancelToken: new CancelToken(function executor(c) {
          _cancelToken = c
        }),
      }
    ).then(res => {

      if (_many) {
        const retMydEvaluations = _.chain(res.data.included)
          .filter({type: 'myd_evaluation'})
          .map(item => deserializeMydEvaluation(item, res.data.included))
          .value()

        dispatch(_fetchedMydEvaluations(retMydEvaluations, {
          maxPage: _.chain(res).get('data.meta.count', 0).ceil().value(),
        }))
        resolve(retMydEvaluations)

      } else {
        if (res.data.data === null) {
          dispatch(_fetchedMydEvaluation(false))
          resolve(false)
          return
        }

        const retMydEvaluation = deserializeMydEvaluation(
          _.find(res.data.included, {type: 'myd_evaluation'}),
          res.data.included,
        )

        dispatch(_fetchedMydEvaluation(retMydEvaluation))
        resolve(retMydEvaluation)
      }

    }).catch(err => {
      if (err.__CANCEL__ !== true) {
        reject(err)
      }
    })
  })
}


let fetchMydEvaluationsByPlanningIdCancelToken = null

export const fetchMydEvaluationsByPlanningId = planningId => fetchMydEvaluationsByFieldId(
  '/myd/plannings',
  planningId,
  fetchMydEvaluationsByPlanningIdCancelToken,
  'myd_evaluations.myd_activity,myd_evaluations',
)


let fetchMydEvaluationsByWidgetIdCancelToken = null

export const fetchMydEvaluationByWidgetId = widgetId =>  fetchMydEvaluationsByFieldId(
  '/widgets',
  widgetId,
  fetchMydEvaluationsByWidgetIdCancelToken,
  false,
  'associated_myd_evaluation',
  `associated_myd_evaluation.myd_activity.myd_competences,associated_myd_evaluation.myd_planning.treenodes`,
  {
    'fields[myd_evaluation]': 'myd_activity,myd_planning',
    'fields[myd_activity]': 'id,title,myd_competences,image',
    'fields[myd_competence]': 'id,title',
  }
)


let fetchMydEvaluationsByActivityIdCancelToken = null
let fetchWidgetsByMydEvaluationIdCancelToken = null

export const fetchMydEvaluationsByMydActivityIdOld = activityId =>  fetchMydEvaluationsByFieldId('/myd/activities', activityId, fetchMydEvaluationsByActivityIdCancelToken)

export const fetchMydEvaluationsByMydActivityId = activityId => (
  dispatch => new Promise((resolve, reject) => {
    dispatch(_fetchingMydEvaluations())

    if (fetchMydEvaluationsByActivityIdCancelToken)
      fetchMydEvaluationsByActivityIdCancelToken()

    if (fetchWidgetsByMydEvaluationIdCancelToken)
        fetchWidgetsByMydEvaluationIdCancelToken()

    MydAPI.get(
      `/myd/activities/${activityId}/evaluations`,
      {
        params: {
          include: 'myd_activity.created_by,myd_planning.treenodes,widgets',
          ...defaultFields(),
          sort: 'date',
        },
        cancelToken: new CancelToken(function executor(c) {
          fetchMydEvaluationsByActivityIdCancelToken = c
        }),
      }
    ).then(res => {
      MydAPI.get(
        `/myd/activities/${activityId}/widgets`,
        {
          params: {
            include: 'likes,global_evaluations,treenodes,owner',
            ...widgetDefaultFields()
          },
          cancelToken: new CancelToken(function executor(c) {
            fetchWidgetsByMydEvaluationIdCancelToken = c
          }),
        }
      ).then(widgetsResponse => {
        const retMydEvaluations = _.map(
          res.data.data,
          item => {
            let widgetItems = []
            if ( ! _.isEmpty(widgetsResponse.data.data)) {
              widgetItems = [
                ...widgetsResponse.data.data,
                ...widgetsResponse.data.included,
              ]
            }

            return deserializeMydEvaluation(item, [
              ...widgetItems,
              ..._.filter(
                res.data.included,
                item => item.type !== 'widget'
              ),
            ])
          }
        )

        dispatch(_fetchedMydEvaluations(retMydEvaluations, {
          maxPage: _.chain(res).get('data.meta.count', 0).ceil().value(),
        }))
        resolve(retMydEvaluations)

      })

    }).catch(err => {
      if (err.__CANCEL__ !== true) {
        reject(err)
      }
    })
  })
)


export const fetchMydEvaluationsToDo = (page=1, filters={}) => {
  return dispatch => new Promise((resolve, reject) => {
    dispatch(_fetchingMydEvaluations())

    if ( ! _.isEmpty(filters)) {
      filters = _.reduce(
        filters,
        (red, v, i) => {
          if(i === 'startDate' || i === 'endDate') {
            return {
              ...red,
              [i]: v.format('YYYY-MM-DD'),
            }
          }
          return {
            ...red,
            [i]: v,
          }
        },
        {}
      )
    }

    MydAPI.get(
      '/myd/evaluations/taskstodo',
      {
        params: {
          'page[size]': 30,
          include: 'myd_planning,myd_activity.created_by',
          sort: 'date',
          'page[number]': page,
          ...filters,
        }
      }

    ).then(res => {
      const retMydEvaluations = _.map(res.data.data, item => deserializeMydEvaluation(item, res.data.included))

      dispatch(_fetchedMydEvaluations(retMydEvaluations, {
        maxPage: _.ceil(res.data.meta.count / 10),
      }))
      resolve(retMydEvaluations)

    }).catch(reject)
  })
}

export const fetchMydEvaluation = mydEvaluationId => {
  return dispatch => new Promise((resolve, reject) => {
    dispatch(_fetchingMydEvaluation())

    MydAPI.get(
      `/myd/evaluations/${mydEvaluationId}`,
      {
        include: 'widgets,widgets.likes,widgets.global_evaluations,widgets.treenodes,widgets.owner,myd_activity.myd_competences,myd_planning.treenodes',
      }

    ).then(res => {
      const retMydEvaluation = deserializeMydEvaluation(res.data.data, res.data.included)

      dispatch(_fetchedMydEvaluation(retMydEvaluation))
      resolve(retMydEvaluation)

    }).catch(reject)
  })
}


export const assignWidgetToMydEvaluation = (widgetId, mydEvaluationId, _type='assign') => (
  new Promise((resolve, reject) => {

    let Method = MydAPI.post
    let data = {
      data: {
        type: 'myd_evaluation',
        id: mydEvaluationId,
      },
    }

    if (_type === 'unassign') {
      Method = MydAPI.delete
      data = {data}
    }

    Method(
      `/widgets/${widgetId}/relationships/associated_myd_evaluation`,
      data,
    ).then(resolve).catch(reject)
  })
)


export const unassignWidgetToMydEvaluation = (widgetId, mydEvaluationId) => assignWidgetToMydEvaluation(widgetId, mydEvaluationId, 'unassign')
